import * as Styled from './numbers-and-minutes-screen'

export { Styled }